import Loader from './Loader.jsx';

// Reusable [package × overlay] checkbox matrix. `packages` is the shape
// returned by /api/me/packages (each overlay has an `id` UUID). `value` is
// a Set<overlayId>. `onChange(nextSet)` is called whenever the user toggles
// a box.

export default function GrantsMatrix({ packages, value, onChange, disabled = false }) {
  if (!packages) return <Loader label="Loading packages…" inline size={20} />;
  if (packages.length === 0) {
    return <div className="text-muted small">No packages defined.</div>;
  }

  function toggle(id, on) {
    const next = new Set(value);
    if (on) next.add(id);
    else next.delete(id);
    onChange(next);
  }

  function toggleAll(pkg, on) {
    const next = new Set(value);
    for (const o of pkg.overlays) {
      if (on) next.add(o.id);
      else next.delete(o.id);
    }
    onChange(next);
  }

  return (
    <div>
      {packages.map((p) => {
        const allOn = p.overlays.every((o) => value.has(o.id));
        const someOn = p.overlays.some((o) => value.has(o.id));
        return (
          <div key={p.slug} className="mb-3">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <span className="fw-bold" style={{ color: 'var(--neon-blue)' }}>
                ◆ {p.name}
              </span>
              <button
                type="button"
                className="btn-ghost"
                disabled={disabled}
                onClick={() => toggleAll(p, !allOn)}
              >
                {allOn ? 'Uncheck all' : someOn ? 'Check remaining' : 'Check all'}
              </button>
            </div>
            <div className="row g-2">
              {p.overlays.map((o) => (
                <div className="col-md-6 col-lg-4" key={o.id}>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={`grant-${o.id}`}
                      checked={value.has(o.id)}
                      disabled={disabled}
                      onChange={(e) => toggle(o.id, e.target.checked)}
                    />
                    <label className="form-check-label" htmlFor={`grant-${o.id}`}>
                      {o.name}
                    </label>
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
